import loadJsonScript from './load-json-script';

// Office slugs of the races the hotlist sheet rates competitive ("hot"), from
// the `competitive_data` script in index.html (see competitiveSlugs in
// project.config.js). Missing on pages that don't embed it, like embeds.
let competitiveSlugs: Set<string> | null = null;

function isCompetitive(contest: { office_slug: string; election_type: string }) {
  if (!competitiveSlugs) {
    competitiveSlugs = new Set(loadJsonScript('competitive_data') || []);
  }

  // The hotlist rates the general election seats, not special elections
  return (
    contest.election_type !== 'special' &&
    competitiveSlugs.has(contest.office_slug)
  );
}

export default isCompetitive;
